import React, { createContext, useState } from 'react';

const AuthContext = createContext();

const getStoredAuth = () => {
  try {
    const token = localStorage.getItem('access_token');
    const user = JSON.parse(localStorage.getItem('user'));
    const menus = JSON.parse(localStorage.getItem('menus'));

    if (!token || !user) {
      return { isAuthenticated: false, token: null, user: null, menus: [] };
    }

    const payload = JSON.parse(atob(token.split('.')[1]));
    const isExpired = payload.exp && payload.exp * 1000 <= Date.now();

    if (isExpired) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      localStorage.removeItem('menus');
      return { isAuthenticated: false, token: null, user: null, menus: [] };
    }

    return { isAuthenticated: true, token, user, menus: menus || [] };
  } catch {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    localStorage.removeItem('menus');
    return { isAuthenticated: false, token: null, user: null, menus: [] };
  }
};

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(getStoredAuth);

  const login = (token,user,menus=[]) => {
    localStorage.setItem('access_token',token);
    localStorage.setItem('user',JSON.stringify(user));
    localStorage.setItem('menus',JSON.stringify(menus));
    setAuth({isAuthenticated: true, token, user, menus});
  };


  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    localStorage.removeItem('menus');
    setAuth({isAuthenticated: false, token:null, user:null, menus:[] });
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };

